import { render, staticRenderFns } from "./PopSucursal3.vue?vue&type=template&id=45a7f8d1&scoped=true"
import script from "./PopSucursal3.vue?vue&type=script&lang=js"
export * from "./PopSucursal3.vue?vue&type=script&lang=js"
import style0 from "./PopSucursal3.vue?vue&type=style&index=0&id=45a7f8d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a7f8d1",
  null
  
)

export default component.exports